import { BaseFieldRenderer } from './base-field-renderer';
import { FirstNameFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class FirstNameFieldRenderer extends BaseFieldRenderer<FirstNameFieldJsonData> {
    protected override get defaultData(): FirstNameFieldJsonData {
        return {
            id: '',
            type: 'firstname',
            label: TranslateUtils.FIRSTNAME_FIELD.LABEL,
            placeholder: TranslateUtils.FIRSTNAME_FIELD.PLACEHOLDER,
            required: true,
            hiddenLabel: false,
            crmFieldData: {
                mixedType: 'ContactField',
                type: 'Text',
                systemName: 'FirstName',
                name: 'First Name'
            }
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: FirstNameFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'text';
        input.maxLength = 500;

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
